import { defineComponent as d, computed as n } from "vue";
import { signOut as I } from "../../../sign_in/api/services/index.js";
import l from "./index14.js";
import { DropdownMenuItem as o, DropdownMenuTypes as _ } from "@ado/dropdown-menu-ld";
import E from "./index26.js";
import { createMyAccountLink as A } from "../types/index2.js";
import "@ado/acs-standard-library";
import { submitInternalEvent as s } from "@ado/tracking-library";
import { TRACKING_EVENTS as r } from "../../../shared/data/tracking/types/index.js";
import "@ado/dropdown-menu-ld/style.css";
import { useBaseApplicationTranslation as L } from "../../../shared/libraries/local-translations/index.js";
const C = "@overdrive.com", T = d({
  name: "HeaderAccount",
  components: {
    MenuCategory: l,
    HeaderSignedOut: E
  },
  props: {
    user: {
      type: Object,
      required: !0
    },
    config: {
      type: Object,
      required: !0
    },
    isMobile: {
      type: Boolean,
      default: !1
    },
    showMenuItems: {
      type: Boolean,
      default: !0
    }
  },
  setup(e) {
    const u = n(
      () => e.config.myaccountPage
    ), m = n(
      () => e.config.showEstateDashboard
    ), a = n(
      () => e.user.username?.toLowerCase().includes(C)
    ), i = n(
      () => a.value ? "Account" : e.user.username
    ), c = n(() => [
      o.newLinkItem(1, t("header.my-documents"), "/mydocuments/").setOnClickHandler(() => {
        s(
          r.HEADER_EMAIL_DROPDOWN_MY_DOCUMENTS_CLICK
        );
      }).setIsVisible(e.showMenuItems),
      o.newLinkItem(
        2,
        t("header.estate-vault"),
        "/EstateDashboard/"
      ).setOnClickHandler(() => {
        s(
          r.HEADER_EMAIL_DROPDOWN_ESTATE_VAULT_CLICK
        );
      }).setIsVisible(e.showMenuItems && m.value),
      o.newLinkItem(
        3,
        t("header.my-account"),
        A(u.value)
      ).setOnClickHandler(() => {
        s(
          r.HEADER_EMAIL_DROPDOWN_MY_ACCOUNT_CLICK
        );
      }).setIsVisible(e.showMenuItems && !a.value),
      o.newLinkItem(
        4,
        t("header.upgrade-account"),
        "/contracts/order-yudox/index.php?code=ALLLAW"
      ).setIsVisible(e.user.hasFreeAccount && e.showMenuItems),
      o.newButtonItem(5, t("header.sign-out"), () => {
        s(
          r.HEADER_EMAIL_DROPDOWN_SIGN_OUT_CLICK
        ), I();
      }).setIsVisible(e.showMenuItems)
    ]), { t } = L();
    return {
      menuTypes: _,
      menuItems: c,
      t,
      username: i
    };
  }
});
export {
  T as default
};
//# sourceMappingURL=index24.js.map
